function empty() {
  return [];
}

export default function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-selection/src/selectorAll.js
// module id = ../../../../d3-selection/src/selectorAll.js
// module chunks = 4